import React, { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import '../styles/react-select/_react-select.css'
export default function CreatableSelectLicenseCustom({
  value = [],
  onChange,
  height = '32px',
  maxLength = 10
}) {
  const [_value, _setValue] = useState(value)
  const [isError, setIsError] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const components = {
    DropdownIndicator: null
  }
  const createOption = (label) => ({
    label,
    value: label
  })
  const handleKeyDown = (event) => {
    if (!inputValue) return
    if (['Enter', 'Tab'].includes(event.key)) {
      if (_value.length < maxLength) {
        setIsError(false)
        _setValue((prev) => [...prev, createOption(inputValue)])
      } else {
        setIsError(true)
      }
      setInputValue('')
      event.preventDefault()
    }
  }

  useEffect(() => {
    onChange(_value)
  }, [_value, onChange])

  return (
    <div>
      <CreatableSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            minHeight: height,
            maxHeight: height,
            height,
            borderColor: '#dee2e6',
            borderRadius: '0.375rem'
          }),
          placeholder: (provided) => ({
            ...provided,
            paddingBottom: '5px'
          }),
          input: (provided) => ({
            ...provided,
            paddingBottom: 0,
            margin: '0px 2px 2px 0px'
          }),
          valueContainer: (provided) => ({
            ...provided,
            minHeight: height,
            maxHeight: height,
            padding: '0px 0px 0px 6px',
            fontSize: 14
          }),
          clearIndicator: (provided) => ({
            ...provided,
            padding: '6px',
            minHeight: height,
            maxHeight: height
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: '6px',
            minHeight: height,
            maxHeight: height
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            margin: '0px 2px 2px 0px'
          })
        }}
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => _setValue(newValue)}
        onInputChange={(newValue) => {
          newValue.length < 51 && setInputValue(newValue?.replace(/,|\s/g, ''))
        }}
        onKeyDown={handleKeyDown}
        placeholder=""
        value={_value}
      />
      <div style={{ fontSize: 12 }} className="">
        Ex. <span className="bg-dark-subtle">กข123-แพร่</span>{' '}
        <span className="opacity-50"> (กด Enter ↵) </span>
      </div>
      {isError && (
        <div style={{ fontSize: 10 }} className="text-danger">
          * บันทึกข้อมูลได้สูงสุด {maxLength} รายการ
        </div>
      )}
    </div>
  )
}
